export type PlanType = 'free' | 'growth' | 'scale' | 'enterprise';

export const PLANS_NAMES: PlanType[] = [
  'free',
  'growth',
  'scale',
  'enterprise',
];

export const PLAN_PADDLE_IDS = {
  growth: {
    monthly: ['pri_01jrsx591pg72twhvs366q2xyn'],
    annual: ['pri_01jrsx694q743qvm9m3gbwtzs4'],
  },
  scale: {
    monthly: [
      'pri_01js0st498jfssefp9a86apv09',
      'pri_01jrsx99emfeckndz1rwbeefsj',
    ],
    annual: ['pri_01jrsx831hxaw34ym9vv5cyf73'],
  },
  enterprise: {
    monthly: [],
    annual: [],
  },
};
